(() => {
  const configNode = document.getElementById('FilameltFinderConfig');
  if (!configNode) return;
  const labels = JSON.parse(configNode.textContent);
  const params = new URLSearchParams(location.search);
  const storageKey = 'filamelt-caliber-v1';
  const clean = value => value.toLocaleLowerCase().trim().replace(/,/g, '.').replace(/\s+/g, ' ');
  const unique = values => [...new Set(values)];
  const pilotHubHandles = new Set([
    'kaliber-308-win', 'kaliber-223-rem', 'kaliber-9-mm-luger', 'kaliber-22-lr',
    'kaliber-6-5-creedmoor', 'kaliber-30-06', 'kaliber-8x57-is', 'kaliber-243-win',
    'kaliber-7x64', 'kaliber-300-win-mag',
  ]);
  const remember = value => { try { sessionStorage.setItem(storageKey, value); } catch {} };

  const readIndex = () => {
    const source = document.getElementById('FilameltCaliberIndex');
    if (!source) throw new Error('finder-index');
    const raw = JSON.parse(source.textContent);
    if (!raw || raw.schema_version !== 1 || typeof raw.generated_at !== 'string' || !Array.isArray(raw.groups) || !Array.isArray(raw.allCalibers)) throw new Error('finder-index');
    const ids = new Set();
    const productTypes = new Set();
    const groups = raw.groups.map(group => {
      if (!group || typeof group.id !== 'string' || !group.id.trim() || typeof group.label !== 'string' || !group.label.trim() || typeof group.productType !== 'string' || !group.productType.trim() || !Array.isArray(group.calibers)) throw new Error('finder-index');
      if (ids.has(group.id) || productTypes.has(group.productType)) throw new Error('finder-index');
      ids.add(group.id); productTypes.add(group.productType);
      const calibers = unique(group.calibers);
      if (calibers.some(value => typeof value !== 'string' || !value.trim())) throw new Error('finder-index');
      return { id: group.id, label: group.label, productType: group.productType, calibers };
    });
    const union = unique(groups.flatMap(group => group.calibers));
    if (unique(raw.allCalibers).length !== raw.allCalibers.length || raw.allCalibers.some(value => typeof value !== 'string' || !value.trim()) || raw.allCalibers.length !== union.length || raw.allCalibers.some(value => !union.includes(value))) throw new Error('finder-index');
    const hubs = raw.hubs === undefined ? [] : raw.hubs;
    if (!Array.isArray(hubs)) throw new Error('finder-index');
    const hubCalibers = new Set();
    const hubHandles = new Set();
    const cleanHubs = hubs.map(hub => {
      if (!hub || typeof hub.caliber !== 'string' || !hub.caliber.trim() || typeof hub.label !== 'string' || !hub.label.trim() || typeof hub.handle !== 'string' || !/^kaliber-[a-z0-9-]+$/.test(hub.handle) || !raw.allCalibers.includes(hub.caliber) || hubHandles.has(hub.handle)) throw new Error('finder-index');
      const productCalibers = hub.productCalibers === undefined ? [hub.caliber] : hub.productCalibers;
      if (!Array.isArray(productCalibers) || !productCalibers.length || !productCalibers.includes(hub.caliber) || unique(productCalibers).length !== productCalibers.length || productCalibers.some(value => typeof value !== 'string' || !value.trim() || !raw.allCalibers.includes(value) || hubCalibers.has(value))) throw new Error('finder-index');
      productCalibers.forEach(value => hubCalibers.add(value)); hubHandles.add(hub.handle);
      return { caliber: hub.caliber, productCalibers, label: hub.label, handle: hub.handle };
    });
    return { groups: groups.filter(group => group.calibers.length), allCalibers: raw.allCalibers, hubs: cleanHubs };
  };
  let sharedIndex;
  let indexError = false;
  try { sharedIndex = readIndex(); } catch { indexError = true; }

  const available = (index, productType) => unique(index.groups
    .filter(group => !productType || group.productType === productType)
    .flatMap(group => group.calibers));

  const initFinder = form => {
    if (form.dataset.fmFinderReady === 'true') return;
    form.dataset.fmFinderReady = 'true';
    const input = form.querySelector('[role="combobox"]');
    const list = form.querySelector('[role="listbox"]');
    const kind = form.querySelector('select');
    const submit = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-fm-finder-status]');
    let matches = [];
    let active = -1;
    let pointerInList = false;

    const close = () => {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    };
    const updateGroups = () => {
      const exact = sharedIndex.allCalibers.filter(value => clean(value) === clean(input.value));
      let selectedBecameUnavailable = false;
      [...kind.options].forEach(option => {
        if (!option.value) return;
        const group = sharedIndex.groups.find(item => item.productType === option.value);
        option.disabled = exact.length === 1 && !group.calibers.includes(exact[0]);
        if (option.disabled && option.value === kind.value) selectedBecameUnavailable = true;
      });
      if (selectedBecameUnavailable) kind.value = '';
    };
    const choose = value => {
      input.value = value;
      input.setCustomValidity('');
      updateGroups();
      input.focus();
      close();
    };
    const setActive = next => {
      if (!matches.length) return;
      active = (next + matches.length) % matches.length;
      [...list.children].forEach((option, i) => option.setAttribute('aria-selected', String(i === active)));
      const option = list.children[active];
      input.setAttribute('aria-activedescendant', option.id);
      const optionRect = option.getBoundingClientRect();
      const listRect = list.getBoundingClientRect();
      if (optionRect.top < listRect.top) list.scrollTop -= listRect.top - optionRect.top;
      else if (optionRect.bottom > listRect.bottom) list.scrollTop += optionRect.bottom - listRect.bottom;
    };
    const render = () => {
      const query = clean(input.value);
      matches = available(sharedIndex, kind.value).filter(value => !query || clean(value).includes(query)).slice(0, 12);
      list.replaceChildren(...matches.map((value, index) => {
        const option = document.createElement('li');
        option.id = `${list.id}-Option-${index}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.textContent = value;
        option.addEventListener('click', () => choose(value));
        return option;
      }));
      status.textContent = query && !matches.length ? labels.invalid : '';
      list.hidden = !matches.length;
      input.setAttribute('aria-expanded', String(matches.length > 0));
      active = -1;
      input.removeAttribute('aria-activedescendant');
    };

    if (indexError) {
      status.textContent = status.dataset.error;
      return;
    }
    if (!sharedIndex.groups.length) {
      status.textContent = status.dataset.empty;
      return;
    }
    sharedIndex.groups.forEach(group => {
      const option = document.createElement('option');
      option.value = group.productType;
      option.textContent = group.label;
      kind.append(option);
    });
    const selectedKind = params.get('filter.product-type');
    if ([...kind.options].some(option => option.value === selectedKind)) kind.value = selectedKind;
    const selectedCaliber = params.get('filter.caliber');
    if (selectedCaliber && available(sharedIndex, kind.value).includes(selectedCaliber)) { input.value = selectedCaliber; remember(selectedCaliber); }
    input.disabled = false; kind.disabled = false; submit.disabled = false;
    updateGroups();
    input.addEventListener('focus', render);
    input.addEventListener('input', () => { input.setCustomValidity(''); updateGroups(); render(); });
    input.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); if (list.hidden) render(); setActive(active < 0 ? 0 : active + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); if (list.hidden) render(); setActive(active < 0 ? matches.length - 1 : active - 1); }
      else if (event.key === 'Enter' && active >= 0) { event.preventDefault(); choose(matches[active]); }
      else if (event.key === 'Escape') { event.preventDefault(); close(); }
      else if (event.key === 'Tab') close();
    });
    list.addEventListener('pointerdown', () => { pointerInList = true; });
    list.addEventListener('pointercancel', () => { pointerInList = false; });
    list.addEventListener('pointerup', () => setTimeout(() => { pointerInList = false; }, 0));
    input.addEventListener('blur', () => requestAnimationFrame(() => { if (!pointerInList && !form.contains(document.activeElement)) close(); }));
    kind.addEventListener('change', () => { input.setCustomValidity(''); render(); });
    form.addEventListener('submit', event => {
      const exact = available(sharedIndex, kind.value).filter(value => clean(value) === clean(input.value));
      if (exact.length !== 1) { event.preventDefault(); input.setCustomValidity(labels.invalid); input.reportValidity(); return; }
      input.value = exact[0];
      remember(exact[0]);
      const hub = !kind.value && sharedIndex.hubs.find(item => item.productCalibers.includes(exact[0]));
      if (hub) {
        event.preventDefault();
        const currentAction = new URL(form.action, location.href);
        const hubUrl = new URL(`${labels.root}collections/${hub.handle}`, location.origin);
        currentAction.searchParams.forEach((value, key) => hubUrl.searchParams.append(key, value));
        location.assign(hubUrl.pathname + hubUrl.search + hubUrl.hash);
      } else if (!kind.value) kind.disabled = true;
    });
  };

  const renderHubLinks = () => {
    const nav = document.querySelector('[data-fm-hub-links]');
    if (!nav || !sharedIndex || !sharedIndex.hubs.length) return;
    const list = nav.querySelector('ul');
    const curated = sharedIndex.hubs.filter(hub => pilotHubHandles.has(hub.handle));
    if (!curated.length) return;
    list.replaceChildren(...curated.map(hub => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `${labels.root}collections/${hub.handle}`;
      link.textContent = hub.label;
      item.append(link);
      return item;
    }));
    nav.hidden = false;
  };

  const returnBar = () => {
    const bar = document.querySelector('[data-fm-caliber-return]');
    if (!bar || !sharedIndex || !sharedIndex.allCalibers.length) return;
    let value; try { value = sessionStorage.getItem(storageKey); } catch {}
    if (!value || !sharedIndex.allCalibers.includes(value)) return;
    const link = bar.querySelector('a');
    const url = new URL(labels.collection, location.origin);
    url.searchParams.set('filter.caliber', value);
    link.href = url.pathname + url.search;
    link.textContent = labels.return_to.replace('[caliber]', value);
    bar.hidden = false;
    bar.querySelector('button').onclick = () => { try { sessionStorage.removeItem(storageKey); } catch {} bar.hidden = true; };
  };

  const decorate = data => document.querySelectorAll('.spf-product-card').forEach(card => {
    const title = card.querySelector('.spf-product-card__title a');
    if (!title) return;
    const handle = new URL(title.href, location.origin).pathname.split('/products/')[1];
    const item = data.cards[handle];
    if (!item) return;
    card.classList.add('fm-card');
    if (title.textContent !== item.title) title.textContent = item.title;
    let detail = card.querySelector('.fm-card-detail');
    const options = Array.from(card.querySelectorAll('select[name="id"] option'));
    const capacities = unique(options.map(option => option.getAttribute('data-option1')).filter(value => /^\d+er$/.test(value || '')));
    const parts = [item.detail, capacities.join(' / ')].filter(Boolean);
    if (parts.length) {
      if (!detail) { detail = document.createElement('p'); detail.className = 'fm-card-detail'; title.parentElement.after(detail); }
      if (detail.textContent !== parts.join(' · ')) detail.textContent = parts.join(' · ');
    }
    const prices = new Set(options.map(option => option.getAttribute('data-price')).filter(Boolean));
    const price = card.querySelector('.spf-product-card__price-wrapper');
    if (prices.size > 1 && price && !price.querySelector('.fm-from')) {
      const from = document.createElement('span'); from.className = 'fm-from'; from.textContent = labels.from + ' '; price.prepend(from);
    }
    if (!card.querySelector('.fm-card-action')) {
      const action = document.createElement('a'); action.className = 'fm-card-action'; action.href = title.getAttribute('href'); action.textContent = labels.configure + ' →';
      (card.querySelector('.spf-product__info') || title.parentElement).append(action);
    }
  });

  const initAll = root => { root.querySelectorAll('[data-fm-finder]').forEach(initFinder); returnBar(); renderHubLinks(); };
  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  fetch(configNode.dataset.catalog).then(response => { if (!response.ok) throw new Error('legacy-catalog'); return response.json(); }).then(legacy => {
    if (!legacy.cards) return;
    decorate(legacy);
    let queued = false;
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; decorate(legacy); }); }).observe(main, { childList: true, subtree: true });
  }).catch(() => {});
})();
